export default "__VITE_ASSET__DY7MwiZH__"